import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io बनाम innRoad',
  heroSubtitle: 'innRoad बुनियादी सुविधा सेट वाले स्वतंत्र होटलों के लिए एक US-आधारित क्लाउड PMS है। HotelStack.io उन्नत राजस्व प्रबंधन, खाद्य एवं पेय/POS, मल्टी-प्रॉपर्टी सहायता और वैश्विक अनुपालन सहित 36 मॉड्यूल प्रदान करता है — तुलनीय कीमत पर।',
  overviewComparison: [
    { label: 'कुल मॉड्यूल', hotelstack: '36 एकीकृत मॉड्यूल', competitor: '8+ मूल सुविधाएं' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$100+/माह से' },
    { label: 'मल्टी-प्रॉपर्टी', hotelstack: 'पूर्ण चेन प्रबंधन', competitor: 'समर्थित नहीं' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'उपलब्ध नहीं' },
    { label: 'वैश्विक पहुंच', hotelstack: '40+ देश', competitor: 'US-केंद्रित' },
    { label: 'राजस्व प्रबंधन', hotelstack: 'उन्नत (बिल्ट-इन)', competitor: 'बुनियादी दर उपकरण' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'क्लाउड-बेस्ड PMS', hotelstack: true, competitor: true },
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'आरक्षण प्रबंधन', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'गेस्ट फोलियो प्रबंधन', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'वितरण और बुकिंग',
      features: [
        { name: 'चैनल मैनेजर (100+ OTA)', hotelstack: true, competitor: 'सीमित OTA' },
        { name: 'GDS कनेक्टिविटी', hotelstack: true, competitor: true },
        { name: 'कमीशन-मुक्त बुकिंग इंजन', hotelstack: true, competitor: true },
        { name: 'ग्रुप बुकिंग', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: 'सीमित' },
      ],
    },
    {
      category: 'राजस्व प्रबंधन',
      features: [
        { name: 'डायनामिक प्राइसिंग नियम', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'व्हाट-इफ रेवेन्यू सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: false },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: false },
        { name: 'RevPAR एनालिटिक्स', hotelstack: true, competitor: 'बुनियादी' },
      ],
    },
    {
      category: 'संचालन और खाद्य एवं पेय',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: false },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: false },
        { name: 'हाउसकीपिंग प्रबंधन', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'रखरखाव कार्य आदेश', hotelstack: true, competitor: false },
        { name: 'स्टाफ शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'किचन डिस्प्ले सिस्टम', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'रिपोर्टिंग और अनुपालन',
      features: [
        { name: 'फ्लैश रिपोर्ट', hotelstack: true, competitor: true },
        { name: 'लाभ-हानि विवरण', hotelstack: true, competitor: false },
        { name: 'पेस रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'बहु-मुद्रा बिलिंग', hotelstack: true, competitor: false },
        { name: 'क्षेत्रीय कर अनुपालन', hotelstack: true, competitor: 'केवल US' },
        { name: 'कस्टम रिपोर्ट बिल्डर', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: 'सीमित' },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। वैश्विक बहु-मुद्रा सहायता। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य। निःशुल्क ऑनबोर्डिंग और माइग्रेशन।',
    competitorNote: '$100+/माह से कोट-आधारित मूल्य। सीमित अंतरराष्ट्रीय सुविधाओं के साथ US-केंद्रित। कोई खाद्य एवं पेय, कोई मल्टी-प्रॉपर्टी, कोई उन्नत एनालिटिक्स नहीं।',
  },
  advantages: [
    'लगभग आधी शुरुआती कीमत पर चार गुना मॉड्यूल (36 बनाम 8+)',
    'पूर्ण मल्टी-प्रॉपर्टी चेन प्रबंधन — innRoad केवल सिंगल संपत्तियों को सपोर्ट करता है',
    'POS, रूम सर्विस, किचन डिस्प्ले और मेनू प्रबंधन के साथ पूर्ण खाद्य एवं पेय मॉड्यूल',
    'डायनामिक प्राइसिंग, पूर्वानुमान और सिम्युलेटर के साथ उन्नत राजस्व प्रबंधन',
    'innRoad के US-केवल फोकस के मुकाबले 40+ देशों में वैश्विक पहुंच',
    'अंतरराष्ट्रीय संपत्तियों के लिए बहु-मुद्रा बिलिंग और क्षेत्रीय कर अनुपालन',
    'लॉयल्टी प्रोग्राम, अतिथि CRM और स्वचालित संचार शामिल',
    '24/7 समर्पित सहायता के साथ निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'innRoad US-आधारित स्वतंत्र होटलों के लिए एक सीधा क्लाउड PMS है जिन्हें बुनियादी आरक्षण और फ्रंट डेस्क प्रबंधन की आवश्यकता है। HotelStack.io चार गुना मॉड्यूल, मल्टी-प्रॉपर्टी सहायता, खाद्य एवं पेय/POS, उन्नत राजस्व उपकरण और वैश्विक पहुंच के साथ एक कहीं अधिक व्यापक प्लेटफॉर्म प्रदान करता है — सभी कम कीमत पर। बुनियादी PMS आवश्यकताओं से आगे बढ़ने की योजना बनाने वाले किसी भी होटल के लिए, HotelStack.io स्पष्ट विकल्प है।',
    bestFor: [
      'बुनियादी PMS से पूर्ण प्लेटफॉर्म में अपग्रेड चाहने वाले स्वतंत्र होटल',
      'innRoad में कमी वाले खाद्य एवं पेय, POS और संचालन उपकरणों की आवश्यकता वाली संपत्तियां',
      'बहु-मुद्रा और अनुपालन उपकरणों की आवश्यकता वाले अंतरराष्ट्रीय विस्तार करने वाले होटल',
      'भविष्य के विकास के लिए मल्टी-प्रॉपर्टी प्रबंधन चाहने वाली संपत्तियां',
      'बुनियादी दर सेटिंग से परे उन्नत राजस्व प्रबंधन चाहने वाले होटल',
    ],
  },
  faqItems: [
    { question: 'क्या मैं innRoad से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी माइग्रेशन टीम अतिथि प्रोफाइल, आरक्षण इतिहास, दर योजनाओं और कमरे के कॉन्फिगरेशन सहित innRoad से पूर्ण डेटा ट्रांसफर संभालती है। माइग्रेशन निःशुल्क है और आमतौर पर शून्य डाउनटाइम के साथ 48 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io innRoad की तरह स्वतंत्र US होटलों को सपोर्ट करता है?', answer: 'बिल्कुल। HotelStack.io US और 40+ अन्य देशों में स्वतंत्र होटलों को सपोर्ट करता है। US होटलों को innRoad में कमी वाली सुविधाओं सहित सभी 36 मॉड्यूल मिलते हैं जैसे खाद्य एवं पेय/POS, राजस्व प्रबंधन और मल्टी-प्रॉपर्टी सहायता — $49/माह से शुरू।' },
    { question: 'GDS कनेक्टिविटी के लिए HotelStack.io innRoad से कैसे तुलना करता है?', answer: 'दोनों प्लेटफॉर्म Amadeus और Sabre के माध्यम से GDS कनेक्टिविटी प्रदान करते हैं। HotelStack.io अतिरिक्त रूप से 100+ OTA से वैश्विक स्तर पर जुड़ता है, मेटासर्च एकीकरण प्रदान करता है और कमीशन-मुक्त बुकिंग इंजन (BookMyRoom.io) शामिल करता है — सभी बेस कीमत में शामिल।' },
    { question: 'क्या HotelStack.io innRoad के विपरीत कई संपत्तियों को संभाल सकता है?', answer: 'हां। HotelStack.io में केंद्रीकृत डैशबोर्ड, क्रॉस-प्रॉपर्टी एनालिटिक्स, साझा दर वितरण, ब्रांड मानक प्रवर्तन और समेकित रिपोर्टिंग के साथ पूर्ण चेन प्रबंधन शामिल है। innRoad केवल सिंगल-प्रॉपर्टी संचालन के लिए डिज़ाइन किया गया है।' },
  ],
};

const WEBREZPRO_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io बनाम WebRezPro',
  heroSubtitle: 'WebRezPro छोटे-से-मध्यम होटलों को लक्षित करने वाला अकाउंटिंग फोकस वाला कनाडाई क्लाउड PMS है। HotelStack.io 36 मॉड्यूल, एंटरप्राइज़-ग्रेड UI, उन्नत राजस्व उपकरण और पूर्ण खाद्य एवं पेय/POS के साथ एक आधुनिक, फीचर-समृद्ध प्लेटफॉर्म प्रदान करता है — हॉस्पिटैलिटी की अगली पीढ़ी के लिए डिज़ाइन किया गया।',
  overviewComparison: [
    { label: 'कुल मॉड्यूल', hotelstack: '36 एकीकृत मॉड्यूल', competitor: '10+ मूल सुविधाएं' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$75+/माह से' },
    { label: 'UI/UX गुणवत्ता', hotelstack: 'मॉडर्न डार्क लक्ज़री', competitor: 'कार्यात्मक / पुराना' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'उपलब्ध नहीं' },
    { label: 'राजस्व प्रबंधन', hotelstack: 'उन्नत (बिल्ट-इन)', competitor: 'बुनियादी दर उपकरण' },
    { label: 'मल्टी-प्रॉपर्टी', hotelstack: 'पूर्ण चेन प्रबंधन', competitor: 'सीमित' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'क्लाउड-बेस्ड PMS', hotelstack: true, competitor: true },
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'आरक्षण प्रबंधन', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'गेस्ट फोलियो प्रबंधन', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'अकाउंटिंग और वित्तीय',
      features: [
        { name: 'एकीकृत अकाउंटिंग', hotelstack: true, competitor: true },
        { name: 'लाभ-हानि विवरण', hotelstack: true, competitor: true },
        { name: 'प्राप्य खाते', hotelstack: true, competitor: true },
        { name: 'बहु-मुद्रा बिलिंग', hotelstack: true, competitor: 'सीमित' },
        { name: 'क्षेत्रीय कर अनुपालन', hotelstack: true, competitor: 'CAD/USD केंद्रित' },
        { name: 'कस्टम इनवॉइस टेम्पलेट', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'राजस्व और वितरण',
      features: [
        { name: 'चैनल मैनेजर (100+ OTA)', hotelstack: true, competitor: 'कम OTA' },
        { name: 'डायनामिक प्राइसिंग नियम', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'व्हाट-इफ रेवेन्यू सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: false },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: false },
        { name: 'कमीशन-मुक्त बुकिंग इंजन', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'खाद्य एवं पेय और संचालन',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: false },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: false },
        { name: 'किचन डिस्प्ले सिस्टम', hotelstack: true, competitor: false },
        { name: 'हाउसकीपिंग प्रबंधन', hotelstack: true, competitor: true },
        { name: 'रखरखाव कार्य आदेश', hotelstack: true, competitor: false },
        { name: 'स्टाफ शेड्यूलिंग', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'अतिथि और एंटरप्राइज़',
      features: [
        { name: '360-डिग्री अतिथि प्रोफाइल', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'लॉयल्टी प्रोग्राम प्रबंधन', hotelstack: true, competitor: false },
        { name: 'अतिथि संचार ऑटोमेशन', hotelstack: true, competitor: 'सीमित' },
        { name: 'चेन डैशबोर्ड', hotelstack: true, competitor: 'सीमित' },
        { name: 'क्रॉस-प्रॉपर्टी एनालिटिक्स', hotelstack: true, competitor: false },
        { name: 'ब्रांड मानक प्रवर्तन', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: false },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: false },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। आधुनिक एंटरप्राइज़-ग्रेड UI। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य। निःशुल्क ऑनबोर्डिंग और माइग्रेशन।',
    competitorNote: '$75+/माह CAD से प्रति-कमरा मूल्य। कार्यात्मक लेकिन पुराना इंटरफेस। सीमित खाद्य एवं पेय, सीमित मल्टी-प्रॉपर्टी, मुख्य रूप से उत्तरी अमेरिकी सहायता।',
  },
  advantages: [
    'आधुनिक एंटरप्राइज़-ग्रेड इंटरफेस के साथ तीन गुना से अधिक मॉड्यूल (36 बनाम 10+)',
    'POS, रूम सर्विस और किचन प्रबंधन के साथ पूर्ण खाद्य एवं पेय मॉड्यूल शामिल',
    'डायनामिक प्राइसिंग, पूर्वानुमान और व्हाट-इफ सिम्युलेटर के साथ उन्नत राजस्व प्रबंधन',
    'WebRezPro के कार्यात्मक लेकिन पुराने इंटरफेस के मुकाबले 2026 के लिए डिज़ाइन किया गया आधुनिक डार्क लक्ज़री UI',
    'केंद्रीकृत एनालिटिक्स और दर वितरण के साथ पूर्ण मल्टी-प्रॉपर्टी चेन प्रबंधन',
    'WebRezPro के उत्तरी अमेरिकी फोकस के मुकाबले 40+ देशों में वैश्विक पहुंच',
    'पुनः बुकिंग के लिए लॉयल्टी प्रोग्राम, अतिथि CRM और स्वचालित संचार',
    '24/7 समर्पित सहायता के साथ निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'WebRezPro छोटे-से-मध्यम उत्तरी अमेरिकी होटलों के लिए मजबूत अकाउंटिंग सुविधाओं वाला एक विश्वसनीय कनाडाई PMS है। हालांकि, इसका पुराना UI, सीमित सुविधा सेट, और खाद्य एवं पेय, उन्नत राजस्व उपकरणों और एंटरप्राइज़ स्केलेबिलिटी की कमी इसे 2026 में कम प्रतिस्पर्धी विकल्प बनाती है। HotelStack.io एक आधुनिक, व्यापक प्लेटफॉर्म प्रदान करता है जो अकाउंटिंग में WebRezPro की बराबरी करता है जबकि 22+ अतिरिक्त मॉड्यूल, विश्व-स्तरीय इंटरफेस और वैश्विक क्षमताएं जोड़ता है।',
    bestFor: [
      'अकाउंटिंग गहराई बनाए रखते हुए आधुनिक UI अपग्रेड चाहने वाले होटल',
      'बुनियादी PMS से परे खाद्य एवं पेय, POS और किचन प्रबंधन की आवश्यकता वाली संपत्तियां',
      'उन्नत राजस्व प्रबंधन और डायनामिक प्राइसिंग उपकरण चाहने वाले होटल',
      'उत्तरी अमेरिका से परे अंतरराष्ट्रीय विस्तार करने वाली संपत्तियां',
      'पूर्ण मल्टी-प्रॉपर्टी चेन प्रबंधन की आवश्यकता वाले बढ़ते होटल समूह',
    ],
  },
  faqItems: [
    { question: 'क्या मैं WebRezPro से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी माइग्रेशन टीम अतिथि प्रोफाइल, आरक्षण इतिहास, दर योजनाओं, अकाउंटिंग डेटा और कमरे के कॉन्फिगरेशन सहित WebRezPro से पूर्ण डेटा ट्रांसफर संभालती है। माइग्रेशन निःशुल्क है और आमतौर पर शून्य डाउनटाइम के साथ 48 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io WebRezPro अकाउंटिंग क्षमताओं की बराबरी करता है?', answer: 'हां। HotelStack.io में एकीकृत अकाउंटिंग, लाभ-हानि विवरण, प्राप्य खाते, कस्टम इनवॉइसिंग और बहु-मुद्रा बिलिंग शामिल है। साथ ही, यह खाद्य एवं पेय, राजस्व प्रबंधन, अतिथि CRM और मल्टी-प्रॉपर्टी प्रबंधन सहित 22+ अतिरिक्त मॉड्यूल जोड़ता है जो WebRezPro में नहीं हैं।' },
    { question: 'HotelStack.io का UI WebRezPro से कैसे तुलना करता है?', answer: 'HotelStack.io में नवीनतम वेब तकनीकों से निर्मित आधुनिक डार्क लक्ज़री इंटरफेस है, जो सभी उपकरणों पर रेस्पॉन्सिव डिज़ाइन प्रदान करता है। WebRezPro में कार्यात्मक लेकिन पुराना इंटरफेस है जो वेब अनुप्रयोगों के पहले युग के लिए डिज़ाइन किया गया था।' },
    { question: 'क्या HotelStack.io वर्तमान में WebRezPro उपयोग करने वाली कनाडाई संपत्तियों के लिए उपयुक्त है?', answer: 'बिल्कुल। HotelStack.io CAD सहित बहु-मुद्रा बिलिंग, कनाडाई कर अनुपालन (GST/HST/PST) और सभी प्रमुख उत्तरी अमेरिकी OTA कनेक्शन का समर्थन करता है। कई कनाडाई संपत्तियां अतिरिक्त मॉड्यूल और आधुनिक अनुभव के लिए स्विच करती हैं।' },
  ],
};


export const COMPARISON_HI_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_HI,
  'hotelstack-vs-webrezpro': WEBREZPRO_HI,
};
